import Reveal from '@/components/base/Reveal';
import { latestScoops } from '@/mocks/home';

function LatestScoops() {
  const [lead, ...rest] = latestScoops;

  return (
    <section id="latest" className="w-full bg-background-100 py-20 md:py-28">
      <div className="max-w-shell mx-auto px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
            <div>
              <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-secondary-600 font-label">
                <i className="ri-file-list-line"></i>
                LATEST EXPOSE
              </span>
              <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                最新爆料
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl">
                持续更新的网红爆料内幕，每条线索都保留原始形态：标题、短摘要与关键时间点，方便你自己判断真伪。
              </p>
            </div>
            <a
              href="#zones"
              className="self-start md:self-auto inline-flex items-center gap-1.5 text-sm text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部深挖专区
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <a
            href="#zones"
            className="group mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-2 rounded-lg overflow-hidden bg-background-50 border border-background-200 cursor-pointer"
          >
            <div className="w-full h-64 sm:h-72 lg:h-full lg:min-h-[360px] overflow-hidden">
              <img
                src={lead.cover}
                alt={`${lead.title} - ${lead.category}爆料封面图`}
                title={`${lead.title} 网红爆料`}
                className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
            <div className="p-6 md:p-9 flex flex-col justify-center">
              <div className="flex items-center gap-3">
                <span className="px-2.5 py-1 rounded-md bg-primary-100 text-primary-800 text-xs">
                  {lead.category}
                </span>
                <span className="text-xs text-foreground-500">独家整理</span>
              </div>
              <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                {lead.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
              <div className="mt-6 flex items-center gap-5 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line"></i>
                  {lead.time}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line"></i>
                  {lead.views} 阅读
                </span>
              </div>
            </div>
          </a>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
          {rest.map((item, index) => (
            <Reveal key={item.id} delay={index * 90}>
              <a
                href="#zones"
                className="group flex flex-col h-full rounded-lg overflow-hidden bg-background-50 border border-background-200 cursor-pointer"
              >
                <div className="w-full h-52 overflow-hidden">
                  <img
                    src={item.cover}
                    alt={`${item.title} - ${item.category}爆料封面图`}
                    title={`${item.title} 网红爆料`}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-700"
                  />
                </div>
                <div className="p-5 md:p-6 flex flex-col flex-1">
                  <span className="self-start px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                    {item.category}
                  </span>
                  <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-3 flex-1">
                    {item.summary}
                  </p>
                  <div className="mt-5 flex items-center gap-4 text-xs text-foreground-500">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-time-line"></i>
                      {item.time}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-eye-line"></i>
                      {item.views}
                    </span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LatestScoops;